module.exports = __webpack_public_path__ + "static/media/Sport.17cd3de9.svg";